<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7Tz4qC/tc-custom/9781250033499.jpg?1719548901749" alt="This image is the cover for the book Under the Knife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Under the Knife
      </h1>
      <p class="bookDescription body article font2">
        <p>Biotechnology tycoon Morgan Finney is highly intelligent but shy and emotionally fragile. When his beloved wife Jenny dies of complications during a surgery led by Dr. Rita Wu, Finney’s grief turns to rage. He vows to kill Rita just as he believes she killed his wife. <br/><br/>But first he will systematically destroy her life. He will take what is precious to her just as she did to him. Aided by a mysterious man, Finney uses advanced medical technology to ruin Rita’s reputation and bring her to the brink of madness. Alone, fighting for her sanity and life, Rita reaches out to her to former lover, Dr. Spencer Cameron, for help. Together they must fight to uncover Finney’s horrific intentions and race to stop him before it’s too late.<br/><br/>Terrifying and captivating, Kelly Parsons's <i>Under the Knife</i> is a heart pounding thriller that will have readers on the edge of their seats up to the very last page.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Parsons
      </h2>
      
      <p class="authorDescription body article">KELLY PARSONS is a board-certified urologist with degrees from Stanford University, the University of Pennsylvania, and Johns Hopkins, and he is on the faculty at the University of California, San Diego.  He lives with his family in Southern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?599ceed2